import React from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getNetworkStatus, getUserMasterData } from "../../../selectors/selector";
import { showNetworkAlert } from "../../../actions/App/action";
import { ToastMessage } from "../../../utils/ToastMessage";
import { OOPS_MESSAGE, ADD_CAPACITY_SUCCESS } from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { ICapacityPayload } from "../../../schemas/manage/manage.Schema";
import { CapacityModel } from "../../../models/manage/capacity.model";
import {
  addManageCapacity,
  getCountryStateCodes
} from "../../../actions/manage/action";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { AddManageCapacity } from "../../../web/pages/ManageCapacity";
import reducer from "../../../reducers/manage/reducer";
import saga from "../../../saga/Manage/saga";
import { compose } from "redux";
import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from "../../../utils/injectReducer";
import { countryStateCodesSelector } from "../../../selectors/Manage/selector";

export const ManagCapacityAddContainer: React.FC<any> = (props: any) => {
  const { isNetWorkAvailable, showNetworkAlert, history, userDetails } = props;
  setScreenName("screen_manageCapacityAdd_container");
  const handleSubmit = (input: ICapacityPayload, clearFields: Function) => {
    if (!isNetWorkAvailable) {
      showNetworkAlert();
      return true;
    }
    const capacityModel = new CapacityModel();
    const query = capacityModel.addCapacity();
    const callback = (status: boolean) => {
      ToastMessage.show(status ? ADD_CAPACITY_SUCCESS : OOPS_MESSAGE);
      // Analytics implementation
      logEvent(
        status
          ? EVENT.UE_MANAGE_CAPACITY_SUCCESS
          : EVENT.UE_MANAGE_CAPACITY_FAILED,
        {
          screen: SCREEN.MANAGE_CAPACITY_ADDEDIT,
          carrierId: (userDetails?.memberDetailsResponse?.member?.carrierId) || "",
          capacityType: "lane", // TODO <lane/truck>
        }
      );
      clearFields();
      history.push(`/app/manage-capacity`, {refreshKey: new Date().getTime()});
    };
    props.addCapacityItem({ params: { query, input }, callback });
  };

  return (
    <AddManageCapacity
      module="manage/ManageMyCapacity"
      {...props}
      handleSubmit={handleSubmit}
      isEditPage={false}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  isNetWorkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  countryStateCodes: countryStateCodesSelector()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  addCapacityItem: (payload: any) => dispatch(addManageCapacity(payload)),
  getCountryStateCodes: () => dispatch(getCountryStateCodes())
});
const key = "manage";

const withSaga = useInjectSaga({ key, saga });
const withReducer = useInjectReducer({ key, reducer });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withSaga,
  withReducer,
  withConnect
)(ManagCapacityAddContainer);
